import { render, staticRenderFns } from "./helpTips.vue?vue&type=template&id=abfa19c8&scoped=true&"
import script from "./helpTips.vue?vue&type=script&lang=js&"
export * from "./helpTips.vue?vue&type=script&lang=js&"
import style0 from "./helpTips.vue?vue&type=style&index=0&id=abfa19c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfa19c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abfa19c8')) {
      api.createRecord('abfa19c8', component.options)
    } else {
      api.reload('abfa19c8', component.options)
    }
    module.hot.accept("./helpTips.vue?vue&type=template&id=abfa19c8&scoped=true&", function () {
      api.rerender('abfa19c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/helpTips.vue"
export default component.exports